/**
 * List of constants for the application
 */

export const CAPI_PROXY_URL = 'checkout-api/api/';
export const CAPI_PROXY_URL_v2 = 'checkout-api/api/2.0/';

export const addons = {
    INSTALLATION: 'installation',
    HAULAWAY: 'haulaway',
} as const;

export const STATES = [
    { title: '', value: '' },
    { title: 'AL', value: 'AL' },
    { title: 'AK', value: 'AK' },
    { title: 'AZ', value: 'AZ' },
    { title: 'AR', value: 'AR' },
    { title: 'CA', value: 'CA' },
    { title: 'CO', value: 'CO' },
    { title: 'CT', value: 'CT' },
    { title: 'DE', value: 'DE' },
    { title: 'FL', value: 'FL' },
    { title: 'GA', value: 'GA' },
    { title: 'HI', value: 'HI' },
    { title: 'ID', value: 'ID' },
    { title: 'IL', value: 'IL' },
    { title: 'IN', value: 'IN' },
    { title: 'IA', value: 'IA' },
    { title: 'KS', value: 'KS' },
    { title: 'KY', value: 'KY' },
    { title: 'LA', value: 'LA' },
    { title: 'ME', value: 'ME' },
    { title: 'MD', value: 'MD' },
    { title: 'MA', value: 'MA' },
    { title: 'MI', value: 'MI' },
    { title: 'MN', value: 'MN' },
    { title: 'MS', value: 'MS' },
    { title: 'MO', value: 'MO' },
    { title: 'MT', value: 'MT' },
    { title: 'NE', value: 'NE' },
    { title: 'NV', value: 'NV' },
    { title: 'NH', value: 'NH' },
    { title: 'NJ', value: 'NJ' },
    { title: 'NM', value: 'NM' },
    { title: 'NY', value: 'NY' },
    { title: 'NC', value: 'NC' },
    { title: 'ND', value: 'ND' },
    { title: 'OH', value: 'OH' },
    { title: 'OK', value: 'OK' },
    { title: 'OR', value: 'OR' },
    { title: 'PA', value: 'PA' },
    { title: 'RI', value: 'RI' },
    { title: 'SC', value: 'SC' },
    { title: 'SD', value: 'SD' },
    { title: 'TN', value: 'TN' },
    { title: 'TX', value: 'TX' },
    { title: 'UT', value: 'UT' },
    { title: 'VT', value: 'VT' },
    { title: 'VA', value: 'VA' },
    { title: 'WA', value: 'WA' },
    { title: 'WV', value: 'WV' },
    { title: 'WI', value: 'WI' },
    { title: 'WY', value: 'WY' },
] as const;
